module.exports = __webpack_public_path__ + "static/media/intro-photowall-6.1017a195.jpg";